// OUR sentences for the persona AI aids (namespace `context`). ⛔ Never err.message / the server's prose.
// Billing refusals (402 / 503 LOOKUP_FAILED / TENANT_RETIRED) are routed to RunRefusalNotice BEFORE these.
const POST_CODES = {
  PERSONA_PROPOSE_ACTIVE: 'personas.assist.errors.proposeActive',
  PERSONA_PROPOSAL_FAILED: 'personas.assist.errors.proposalFailed',
  PERSONA_JOB_ACTIVE: 'personas.assist.errors.jobActive',
  PERSONA_NOT_FOUND: 'personas.assist.errors.personaNotFound',
  PERSONA_LEGACY_FORMAT: 'personas.errors.legacy',
  INVALID_ENTITY_ID: 'personas.assist.errors.invalidId',
  BRIEF_VALIDATION_ERROR: 'personas.assist.errors.invalidInput',
  TENANT_ADMIN_REQUIRED: 'personas.assist.errors.notAdmin',
};
export function assistErrorCopy(t, err) {
  if (err?.code === 'DOCUMENT_NOT_FOUND') {
    const files = Array.isArray(err?.details?.documents) ? err.details.documents.filter(Boolean) : [];
    return files.length ? t('personas.assist.errors.documentNotFound', { files: files.join(', ') })
      : t('personas.assist.errors.documentNotFoundGeneric');
  }
  if (POST_CODES[err?.code]) return t(POST_CODES[err.code]);
  if (err && typeof err.status === 'number' && err.status >= 500 && err.requestId) {
    return t('personas.assist.errors.server', { ref: err.requestId });
  }
  if (!err || err.status == null) return t('personas.assist.errors.network');
  return t('personas.errors.generic', { code: err.code || err.status });
}

const JOB_CODES = {
  PERSONA_LLM_FAILED: 'personas.assist.jobErrors.llm',
  PERSONA_PROPOSAL_INVALID: 'personas.assist.jobErrors.invalid',
  PERSONA_TRANSLATE_FAILED: 'personas.assist.jobErrors.translate',
  PERSONA_NOT_FOUND: 'personas.assist.jobErrors.personaGone',
  PERSONA_LEGACY_FORMAT: 'personas.assist.jobErrors.personaGone',
  CANCELLED: 'personas.assist.jobErrors.interrupted',
  STALE: 'personas.assist.jobErrors.interrupted',
};
export function jobErrorCopy(t, code) {
  return t(JOB_CODES[code] || 'personas.assist.jobErrors.generic', { code: code || '—' });
}

const DOC_STATUS = ['used', 'no_text', 'missing', 'unsupported', 'error', 'dropped_budget'];
/** One DocumentRecord → our line. */
export function docStatusCopy(t, rec) {
  const key = DOC_STATUS.includes(rec?.status) ? rec.status : 'error';
  const base = t(`personas.assist.docStatus.${key}`);
  return rec?.status === 'used' && rec.truncated ? `${base} ${t('personas.assist.docStatus.truncated')}` : base;
}
